import React, { useEffect, useCallback, useState } from 'react';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
import withStyles from '@mui/styles/withStyles';
import { IconButton } from '@mui/material';
import { CloseOutlined, ArrowBackOutlined, ArrowForwardOutlined, ZoomIn, ZoomOut, Refresh } from '@mui/icons-material';
import ReactPlayer from 'react-player';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

const styles = (theme) => ({
    mainDiv: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.6)',
        zIndex: 111114,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },

    closeIcon: {
        position: 'absolute',
        top: 10,
        right: 10,
        zIndex: 111121,
    },

    wrapper: {
        position: 'relative',
        maxWidth: '90%',
        maxHeight: '90%',
        width: '90%',
        height: '90%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

    _imgTag: {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
    },

    reactPlayer: {
        maxWidth: '100%',
        maxHeight: '100%',
    },

    scrollBtn: {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: 'rgba(0,0,0,0.35)',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        color: '#fff',
        zIndex: 111120,
    },

    leftDiv: {
        left: '10px',
    },

    rightDiv: {
        right: '10px',
    },

    zoomControls: {
        position: 'absolute',
        bottom: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: '10px',
        zIndex: 111122,
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black background
        borderRadius: '8px', // Rounded corners
        padding: '5px 10px', // Padding for spacing
    },

    notAllow: {
        opacity: 0.3,
        cursor: 'not-allowed',
    },
});

function PhotoPreview(props) {
    const { classes, closeEvent, dataArray, index, customWrapperCls, imgCustomCls } = props;
    const [currentIndex, setCurrentIndex] = useState(index || 0);
    const disableNextBtn = dataArray ? dataArray.length - 1 === currentIndex : false;
    const disablePrevBtn = currentIndex === 0;

    const handleNext = () => {
        if (dataArray.length && !disableNextBtn) {
            setCurrentIndex((prevIndex) => prevIndex + 1);
        }
    };

    const handlePrevious = () => {
        if (dataArray.length && !disablePrevBtn) {
            setCurrentIndex((prevIndex) => prevIndex - 1);
        }
    };

    const keyboardBtnFunction = useCallback(
        (event) => {
            if (event.keyCode === 27) {
                closeEvent();
            }
            if (event.keyCode === 37) {
                handlePrevious();
            }
            if (event.keyCode === 39) {
                handleNext();
            }
        },
        [currentIndex]
    );

    useEffect(() => {
        window.addEventListener('keydown', keyboardBtnFunction, false);

        return () => {
            window.removeEventListener('keydown', keyboardBtnFunction, false);
        };
    }, [keyboardBtnFunction]);

    return (
        <div className={classes.mainDiv}>
            <span className={classes.closeIcon}>
                <IconButton onClick={closeEvent} size="large">
                    <CloseOutlined style={{ color: '#fff' }} />
                </IconButton>
            </span>
            <div className={`${classes.wrapper} ${customWrapperCls || ''}`}>
                {dataArray && dataArray[currentIndex].type === 'image' ? (
                    <TransformWrapper>
                        {({ zoomIn, zoomOut, resetTransform }) => (
                            <>
                                <TransformComponent>
                                    <ImgLazyLoad>
                                        <img
                                            src={dataArray[currentIndex].path}
                                            alt="preview"
                                            className={`${classes._imgTag} ${imgCustomCls || ''}`}
                                        />
                                    </ImgLazyLoad>
                                </TransformComponent>

                                {/* Zoom Controls */}
                                <div className={classes.zoomControls}>
                                <IconButton onClick={() => zoomIn()} size="large" style={{ color: '#fff', textShadow: '0px 0px 5px rgba(0,0,0,0.8)' }}>
                                    <ZoomIn />
                                </IconButton>
                                <IconButton onClick={() => zoomOut()} size="large" style={{ color: '#fff', textShadow: '0px 0px 5px rgba(0,0,0,0.8)' }}>
                                    <ZoomOut />
                                </IconButton>
                                <IconButton onClick={() => resetTransform()} size="large" style={{ color: '#fff', textShadow: '0px 0px 5px rgba(0,0,0,0.8)' }}>
                                    <Refresh />
                                </IconButton>
                                </div>
                            </>
                        )}
                    </TransformWrapper>
                ) : (
                    <ReactPlayer
                        url={dataArray[currentIndex].path}
                        controls
                        className={classes.reactPlayer}
                        width="100%"
                        height="100%"
                        config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                        onContextMenu={(e) => e.preventDefault()}
                    />
                )}
            </div>

            {/* Next/Previous Buttons */}
            <div
                className={`${classes.scrollBtn} ${classes.leftDiv} ${disablePrevBtn ? classes.notAllow : ''}`}
                onClick={!disablePrevBtn ? handlePrevious : undefined}
            >
                <ArrowBackOutlined />
            </div>
            <div
                className={`${classes.scrollBtn} ${classes.rightDiv} ${disableNextBtn ? classes.notAllow : ''}`}
                onClick={!disableNextBtn ? handleNext : undefined}
            >
                <ArrowForwardOutlined />
            </div>
        </div>
    );
}

export default withStyles(styles)(PhotoPreview);